"use client";

import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { useEffect } from "react";
import { useAnalytics } from "use-analytics";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Collection_Fragment } from "#/graphql/shopify-storefront/fragments";
import { Tracking_Product_Fragment } from "./graphql";

export function Tracking({
  productMasked,
}: {
  productMasked: FragmentOfShopifyStorefront<typeof Tracking_Product_Fragment>;
}) {
  const { track } = useAnalytics() || {};

  const product = readFragmentShopifyStorefront(
    Tracking_Product_Fragment,
    productMasked,
  );

  useEffect(() => {
    const { collectionsConnectionMasked } = product;

    const collections = collectionsConnectionMasked.edges.map(
      ({ node: collectionMasked }) =>
        readFragmentShopifyStorefront(Collection_Fragment, collectionMasked),
    );

    const item = {
      discount:
        Number.parseInt(product.priceRange.minVariantPrice.amount) -
        Number.parseInt(product.compareAtPriceRange.minVariantPrice.amount),
      item_brand: product.vendor,
      item_category: collections?.[0]?.title,
      item_id: product.id,
      item_name: product.title,
      price: product.priceRange.minVariantPrice.amount,
    };

    if (track) {
      track("view_item", {
        currency: product.compareAtPriceRange.minVariantPrice.currencyCode,
        type: "product",
        value: product.priceRange.minVariantPrice.amount,
        items: [item],
      });
    }
  }, [product, track]);

  return null;
}
